import type { BulkTaskEditPreview } from "@/types/models";

export function requiresBulkScheduleReview(
  impacts: readonly BulkTaskEditPreview["scheduleImpacts"][number][],
): boolean {
  return impacts.some((impact) => !impact.direct && impact.kind !== "summary");
}
